'use client';

import cx from 'classnames';
import { ChangeEventHandler, ReactNode, useRef } from 'react';
import { useController, useFormContext } from 'react-hook-form';

import styles from './otpInput.module.scss';

interface Props {
  name: string;
  suffix?: ReactNode;
  placeholder?: string;
  isError?: boolean;
  disabled?: boolean;
  className?: string;
  length?: number;
  onChange?: () => void;
}

export const OtpInput = ({
  name,
  isError,
  className,
  suffix,
  placeholder,
  disabled,
  length = 6,
  onChange: onChangeCallback,
}: Props) => {
  const divRef = useRef<HTMLDivElement>(null);
  const { control } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({ name, control });

  const onCustomChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const newValue = e.currentTarget.value.replace(/[^0-9]/g, '');
    onChange(newValue);
    onChangeCallback?.();
  };

  return (
    <div className={cx(styles.wrapper, styles.large, className, { [styles.isError]: isError })} ref={divRef}>
      <input
        type='text'
        name='otpCode'
        className={styles.input}
        value={value || ''}
        maxLength={length}
        onChange={onCustomChange}
        inputMode='numeric'
        autoComplete='off'
        autoCorrect='off'
        placeholder={placeholder}
        disabled={disabled}
      />
      {suffix}
    </div>
  );
};
